jQuery('.slide-in-bottom').waypoint(function(direction) {
		jQuery(this.element).animate({ top: 0, opacity: 1 }, 300);
	}, {
		offset: '85%'//'bottom-in-view'
	}
);
